// French translations
const FrTranslations = {
    translation: {
      welcome: 'Bienvenue',
      about: 'À propos',
      contact: 'Contact',
      viewProject: 'Voir le Projet'
    },
    header:{
        blogs: 'Articles',
        cta: 'Contactez-nous',
    },
    mainText: {
        slogan: 'Nous construisons des sites Web',
        tailored: 'sur mesure',
        slogan1: 'pour votre entreprise',
        slogan2: 'Faire de votre vision, notre',
        workOfArt: 'œuvre d\'art',
        headline1: 'Nous Mettons Votre Entreprise',
        headline2: 'On the Web',
        subheading: 'et Devant la Concurrence',
        landingParagraph: 'De la stratégie et conception au développement et à l\'intégration CMS, nous créons des sites web qui travaillent aussi dur que vous. Adaptés aux moyennes et grandes entreprises, avec la flexibilité dont votre équipe marketing a besoin pour prospérer.',
        offeringTitle: 'Sites web sur mesure qui convertissent vos visiteurs en clients.',
        offeringText: 'Experts en design, développement et optimisation UI/UX, nous créons des solutions digitales sur mesure pour atteindre vos objectifs.',
        offeringText2: 'Une solution clé en main, prête à booster votre présence en ligne.',        
        portfolio: 'Découvrez Nos Chefs-d\'Œuvre',
        commingSoon: 'Bientôt disponible ...',
        struggle: 'Vous avez du mal à montrer votre travail le plus important au monde ?',
        struggle2: 'Cliquez n\'importe où pour mettre en lumière',
        struggle3: 'Mettez en lumière vos réalisations',
        struggle4: 'Donner vie à votre meilleur travail et les partager avec le monde',
        yourProject : 'Transformez Votre Vision en Réalité !',
        yourProjectText: 'Libérez le potentiel de votre entreprise avec notre solution clé-en-main !',
        yourProjectSub: 'Votre Projet, Ici !',
    },
    serviceText: {
        title: 'élevez votre performance avec nos services professionnels',
        webDevelopment: 'Development Web',
        webDevelopmentText: 'Nous concevons et développons des sites Web qui sont beaux, fonctionnels et optimisés pour transformer vos visiteurs en clients.',
        webDesign: 'Création de sites web',
        webDesignText: 'Nous créons des sites Web captivants et contemporains qui allient beauté, fonctionnalité et convivialité pour refléter votre marque.',
        webHosting: 'Hébergement Web',
        webHostingText: 'Nous fournissons un service d\'hébergement sécurisé, fiable et abordable pour votre site Web. Nous proposons également l\'enregistrement et la gestion de domaines.',
        webMaintenance: 'Maintenance Web',
        webMaintenanceText: 'Nous proposons un service de maintenance de site Web pour garantir que votre site Web est à jour et sécurisé. Nous proposons également un service de refonte de site Web.',
        unlimitedSupport: 'Support illimité',
        unlimitedSupportText: 'Nous sommes toujours disponibles pour vous aider avec toutes les questions que vous pourriez avoir. Nous sommes là pour vous aider à développer votre entreprise.',
        montlyPlan: 'Plan mensuel',
        montlyPlanText: 'Nous proposons différents plans mensuels pour vous aider à démarrer votre site Web. Nous proposons également un plan personnalisé pour répondre à vos besoins.',

    },


    buttonText: {
        scheduling: 'Contactez-nous',
        ourRecentWork: 'Nos récents travaux',
    },

    formText: {
        schedulingAppointment: 'Engagez-vous avec notre expertise',
        schedulingSlogan:'Nous vous contacterons dans les plus brefs délais',
        fullname: 'Nom complet',
        email: 'Email',
        phone: 'Numéro de téléphone',
        submit: 'Soumettre',
        submitting: 'Envoi en cours...',
        thankYou: 'Merci',
        responseMessage: "Nous avons bien reçu votre message et vous contacterons sous peu !",
    },

    aboutUs: {
        title: 'Le professionnel derrière la magie',
        subtitle: 'Nous sommes des professionnels passionnés dédiés à aider les entreprises à grandir et réussir. Nous proposons des services complets de conception et développement web. Nous créons des sites web, des applications web et des expériences web. Satisfaction à 100% garantie.',
        vision: "Réaliser vos rêves numériques",
        visionText: "Chez ontheweb, nous croyons que chaque entreprise peut exploiter pleinement son potentiel numérique. Nous ne créons pas simplement des sites web ; nous bâtissons des passerelles vers votre succès. Notre passion nous pousse à repousser les limites du design et du développement web, transformant vos rêves entrepreneuriaux en réalités numériques captivantes. Nous sommes engagés envers l'excellence et votre entière satisfaction. Ensemble, façonnons l'avenir du commerce en ligne. Votre succès est notre vision—réalisons-la ensemble !",
        matanSubtitle: 'Développeur / Designer Principal',
        matanText: 'Salut! Je suis Matan, un développeur full-stack dévoué. Expert dans la création de solutions robustes, j\'excelle dans l\'aide aux entreprises avec un code propre et efficace. Construisons quelque chose d\'incroyable ensemble!',
        matanExtraText:'fondateur',
        
        clickHere: 'Jettez un coup d\'œuil à notre boite d\'outils',
    },
    blog: {
        share: {
            text: 'Vous avez aimé ce que vous avez lu ? Partagez-le avec d\'autres !',
            facebook: 'Facebook',
            twitter: 'Twitter',
            linkedin: 'LinkedIn',
            copyLink: 'Copier le lien',
            linkCopied: 'Lien copié !',
        },
        textToSpeech: {
            start: 'Écouter',
            stop: 'Arrêter',
            error: 'Une erreur s\'est produite avec le service de synthèse vocale. Veuillez réessayer.',
            notSupported: 'La synthèse vocale n\'est pas prise en charge par votre navigateur.'
        }
    },
    toolbox:{
        title: 'Boîte à outils',
        description: 'Une collection d\'outils utiles pour les designers et les développeurs',
        visit: 'Visiter le site',
        categories: {
            all: 'Tous les outils',
            fonts: 'Polices',
            designResources: 'Ressources Design',
            designInspiration: 'Inspiration',
            colors: 'Outils de couleur',
            dev: 'Outils Dev',
            gamesTools: 'Jeux',
            generatorsTools: 'Générateurs',
            webUtils: 'Utilitaires Web',
            ai: 'Outils IA'
        },
        filters: {
            title: 'Filtrer les outils',
            show: 'Afficher les filtres',
            hide: 'Masquer les filtres'
        },
        views: {
            marquee: 'Vue défilante',
            list: 'Vue détaillée',
            toggle: 'Changer de vue'
        },
        search: {
            placeholder: 'Rechercher des outils...',
            noResults: 'Aucun outil trouvé correspondant à votre recherche',
            clear: 'Effacer la recherche'
        },
        suggestToolPrompt: 'Vous ne trouvez pas ce que vous cherchez ? Faites-le nous savoir !',
        suggestToolButton: 'Suggérer un outil',
        ai: {
            assistantButton: 'Recommandations IA',
            modalTitle: 'Recherche d\'outils IA',
            description: 'Décrivez ce que vous recherchez et laissez notre IA trouver les outils parfaits pour vous. Tapez naturellement, comme si vous parliez à un ami.',
            inputPlaceholder: 'Que recherchez-vous ?',
            searchButton: 'Rechercher',
            loadingText: 'Recherche des meilleurs outils pour vous...',
            loadingMessages: [
                'Recherche parmi {{count}} outils...',
                'Analyse de votre demande...',
                'Presque terminé, recherche des meilleures correspondances...',
                'Finalisation des recommandations...',
                'Fouille dans la boîte à outils...',
                'Recherche des outils parfaits pour vous...',
                'Notre IA est en pleine recherche...',
                'Parcours de la collection...',
                'Découverte de pépites cachées...',
                'Préparation de votre liste personnalisée...'
            ],
            resultsTitle: 'Outils recommandés',
            noResults: 'Aucun outil correspondant trouvé. Essayez d\'autres mots-clés.',
            closeButton: 'Fermer'
        },
        suggestTool: {
            title: 'Suggérer un outil',
            subtitle: 'Aidez-nous à développer notre collection d\'outils !',
            placeholders: {
                toolName: 'Nom de l\'outil',
                toolUrl: 'URL de l\'outil',
                category: 'Catégorie d\'outil',
                description: 'Description courte (max 300 caractères)',
                name: 'Nom (optionnel)',
                email: 'Email'
            },
            buttons: {
                generate: 'Générer une description',
                generating: 'Génération...',
                submit: 'Envoyer la suggestion',
                submitting: 'Envoi...'
            },
            validation: {
                toolNameRequired: 'Le nom de l\'outil doit contenir au moins 2 caractères',
                urlInvalid: 'Veuillez entrer une URL valide commençant par http:// ou https://',
                categoryRequired: 'Veuillez sélectionner une catégorie',
                descriptionRequired: 'La description est requise',
                descriptionTooLong: 'La description doit contenir 300 caractères ou moins',
                emailInvalid: 'Veuillez entrer une adresse email valide'
            },
            success: {
                generated: 'Description générée avec succès !',
                submitted: 'Merci ! Votre suggestion a été envoyée.'
            },
            errors: {
                generateFailed: 'Impossible de générer la description. Réessayez ou écrivez la vôtre.',
                submitFailed: 'Échec de l\'envoi. Veuillez réessayer.'
            },
            labels: {
                toolName: 'Nom de l\'outil',
                description: 'Description',
                category: 'Catégorie'
            },
            loading: {
                extractingInfo: 'Extraction des informations de l\'outil...'
            },
            placeholderText: {
                toolName: 'Cliquez pour ajouter le nom de l\'outil',
                description: 'Cliquez pour ajouter une description'
            }
        }
    },

    blogs: {
        title: 'Articles',
        loadMore: 'Charger plus',
        recentPosts: 'Articles récents',
        comingSoon: 'Restez à l\'écoute pour nos derniers articles',
    },

    cta:{
        title: 'Prêt à élever votre entreprise avec ontheweb ?',
        text: 'Faisons de votre vision une réalité !',
    },

    footerQuote: {
        text: 'ontheweb | Mettons votre entreprise sur le Web',
    },

    errorLoadingContent: 'Oups! L\'article que vous recherchez n\'est pas disponible.',
    postNotFound: 'Mais ce n\'est pas grave! Découvrez l\'un de nos autres articles',
    projects: {
        viewProject: 'Voir le projet'
    },

};

export default FrTranslations;
